<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle title="Team"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-start">
            <a href="javascript:void(0);" class="btn btn-success mb-2"
               (click)="onAddUserClick()">
              <i class="mdi mdi-plus mr-2"></i> Add Team Member
            </a>
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>

                <th>S.No.</th>
                <th>Name</th>
                <th>PhoneNumber</th>
                <th>Email</th>
                <th>Branch</th>
                <th>Role</th>
                <!--                <th>Action</th>-->
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of dashboardService.branches; let i= index">

                <td>{{i + 1}}</td>
                <td>{{item.userName}}</td>
                <td>{{item.userPhoneNumber}}</td>
                <td>{{item.userEmail}}</td>
                <td>{{item.branchName}}</td>
                <td>{{item.role}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Contacts model  -->
<ng-template #content role="document" let-modal="close">
  <div class="modal-header pb-0 mb-0">
    <h3>Add Team Member</h3>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="addTeamMember()" [formGroup]="dataForm">
        <div class="form-group">
          <label>Name </label>
          <input class="form-control" placeholder="Enter Name" formControlName="userName"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userName.errors}">
          <div *ngIf="form.userName.touched && form.userName.errors" class="invalid-feedback">
            <span *ngIf="form.userName.errors.required">Name is mandatory.</span>
          </div>
        </div>

        <div class="form-group">
          <label>Phone Number </label>
          <input class="form-control" placeholder="Enter phone number" formControlName="userPhoneNumber"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userPhoneNumber.errors}" minlength="10"
                 onkeyup="this.value=this.value.replace(/[^\d]/,'')">
          <div *ngIf="form.userPhoneNumber.touched && form.userPhoneNumber.errors" class="invalid-feedback">
            <span *ngIf="form.userPhoneNumber.errors.required">Phone Number is mandatory.</span>
            <span *ngIf="form.userPhoneNumber.errors.minlength">Phone number must be 10 characters.</span>
          </div>
        </div>

        <div class="form-group">
          <label>Email </label>
          <input type="email" class="form-control" placeholder="Enter email" formControlName="userEmail"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userEmail.errors}">
          <h6 class="text-small text-muted">NOTE: Email will be used to login the user</h6>
          <div *ngIf="form.userEmail.touched && form.userEmail.errors" class="invalid-feedback">
            <span *ngIf="form.userEmail.errors.required">Email is mandatory.</span>
          </div>
        </div>
        <div class="form-group">
          <label>Branch Name </label>
          <input class="form-control" placeholder="Enter Branch Name" formControlName="branchName"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.branchName.errors}">
          <div *ngIf="form.branchName.touched && form.branchName.errors" class="invalid-feedback">
            <span *ngIf="form.branchName.errors.required">Branch Name is mandatory.</span>
          </div>
        </div>
        <mat-form-field appearance="fill">
          <mat-label>Role</mat-label>
          <mat-select formControlName="roleId">
            <mat-option style="z-index: 999999" *ngFor="let role of roles"
                        [value]="role.roleId">{{role.roleName}}</mat-option>
          </mat-select>
        </mat-form-field>


        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-danger ml-1 mr-2" (click)="modal('close click')">Cancel</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
